module.exports = __webpack_public_path__ + "img/rare-2-xxl.71d6e9b.webp";